import { i18n } from 'src/i18n';
import schemas from 'src/modules/shared/yup/yupImporterSchemas';

export default [
  {
    name: 'username',
    label: 'username',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'nationalID',
    label: 'nationalID',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'name',
    label: 'name',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'lastName',
    label: 'lastName',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'birthDate',
    label: 'birthDate',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'rolName',
    label: 'rolName',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'areaName',
    label: 'areaName',
    schema: schemas.string(
      i18n('entities.appUser.fields.username'),
      {
        required: true,
      },
    ),
  },
];
